$bog_max_list $mol_list
